import {ChangeDetectorRef, Component} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from '../../shared/services/user.service';
import {ModalComponent} from '../../shared/modal/modal.component';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  imports: [ModalComponent, CommonModule, ReactiveFormsModule]
})
export class SupportComponent {
  supportForm: FormGroup;
  isSubmitted = false;
  isError = false;
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private userService: UserService,
    private cdr: ChangeDetectorRef,
  ) {
    this.supportForm = this.fb.group({
      subject: ['', [Validators.required, Validators.minLength(5)]],
      description: ['', [Validators.required, Validators.minLength(5)]]
    });
  }

  submitRequest() {
    if (this.supportForm.invalid) {
      this.supportForm.markAllAsTouched();
      return;
    }

    this.isLoading = true;

    const { subject, description } = this.supportForm.value;
    this.userService.userRequest(subject, description).subscribe({
      next: () => {
        this.isSubmitted = true;
        this.supportForm.reset();
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('[ERROR CAUGHT]', err);
        this.isError = true;
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    });
  }

  goHome() {
    this.isSubmitted = false;
    this.router.navigate(['/dashboard']);
  }

  isFieldInvalid(field: string): boolean {
    const control = this.supportForm.get(field);
    return !!(control && control.invalid && control.touched);
  }
}
